module.exports = __webpack_public_path__ + "img/1K2.6562f821.png";